import React, { useState } from "react";
import { useNavigate } from "react-router";
import NumberPad from "../components/NumberPad";
import Container from "../components/Container";
import OverlayLoading from "../components/OverlayLoading";
import { authenticationService } from "../services/AuthenticationService";
import { useSnackbarContext } from "../components/snackbar/SnackbarContext";

/**
 * ログインページ
 * @class LoginPage
 */
export default function LoginPage() {
  const [employeeNumber, setEmployeeNumber] = useState("");
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbarContext();

  /**
   * ログインする
   * @memberof LoginPage
   */
  const onLogin = async () => {
    try {
      const result = (await authenticationService.login(employeeNumber)).data;
      if (result.success) {
        navigate("/", { replace: true });
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
      showSnackbar("error", error.data.message);
    }
  };
  return (
    <Container title="ログイン" isNotLogin>
      <div id="login-page">
        <section className="login-card" aria-labelledby="login-title">
          <div className="card-head">
            <div className="lock" aria-hidden="true">
              <svg width="46" height="46" viewBox="0 0 48 48" fill="none">
                <rect
                  x="10"
                  y="21"
                  width="28"
                  height="20"
                  rx="4"
                  stroke="currentColor"
                  strokeWidth="3"
                />
                <path
                  d="M16 21v-6a8 8 0 0 1 16 0v6"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
                <path
                  d="M24 29v5"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div>
              <h1 id="login-title">社員番号を入力してください</h1>
              <p className="lead">社員番号を入力し、ログインしてください</p>
            </div>
          </div>

          <label className="field">
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M20 21a8 8 0 0 0-16 0"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
              />
              <circle
                cx="12"
                cy="8"
                r="4"
                stroke="currentColor"
                strokeWidth="1.8"
              />
            </svg>
            <input
              id="employeeNo"
              className="employee-input"
              name="employee_no"
              type="text"
              inputMode="numeric"
              autocomplete="off"
              pattern="[0-9]*"
              maxlength="12"
              placeholder="社員番号"
              aria-label="社員番号"
              value={employeeNumber}
            />
          </label>
          <NumberPad onChange={setEmployeeNumber} isLogin />
          <button
            onClick={onLogin}
            disabled={!employeeNumber}
            className="login-btn"
          >
            ログイン
          </button>
        </section>
      </div>
      <OverlayLoading open={isLoading} />
    </Container>
  );
}
